<template lang="html">
<div class="pgInner adsEdit">

    <div class="headBar">新建选址</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller1" style="height:100%;">

           <el-form ref="ruleForm" :model="params1" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">分类</div>
                     <div class="bContent">
                           <el-form-item>
                               <dic-select code="bgxzfl"
                                    :selectId="params1.officeLocationTypeId"
                                    paramsKey="officeLocationType"
                                    @selectChange="selectChange"
                                    plaText="分类" />
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">楼盘名称</div>
                     <div class="bContent">
                           <el-form-item>
                               <el-input size="medium" class="inpText" v-model="params1.title" placeholder=""></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">位置信息</div>
                     <div class="bContent">
                           <el-form-item>
                               <ads-select @selected="mapChange" :adsList="adsStore"  selectType="1" />
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">地铁信息</div>
                     <div class="bContent">
                           <el-form-item>
                             <dic-select code="dt"
                                  :selectId="params2.subwayLineId"
                                  paramsKey="subwayLine"
                                  @selectChange="selectChange"
                                  plaText="地铁" />
                           </el-form-item>
                           <el-form-item>
                               <el-input size="medium" v-model="params2.subwayStation" placeholder="站点名称"></el-input>
                           </el-form-item>
                           <el-form-item>
                               <el-input size="medium" v-model="params2.distance" placeholder="步行多少米"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">租金</div>
                     <div class="bContent">
                         <div class="">
                           <el-form-item>
                                 <el-input-number size="medium" v-model="params2.rentBegin" :step="0.01" :precision="2"></el-input-number>
                           </el-form-item>
                           <span class="midspan">—</span>
                           <el-form-item>
                                 <el-input-number size="medium" v-model="params2.rentEnd" :step="0.01" :precision="2"></el-input-number>
                           </el-form-item>
                           <div class="tips">
                              元/㎡/天
                           </div>
                         </div>

                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">商圈</div>
                     <div class="bContent">
                         <el-form-item>
                            <el-input size="medium" class="inpText" v-model="params1.officeArea" placeholder="请输入楼盘所在商圈 例：海淀 - 中关村"></el-input>
                         </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">面积</div>
                     <div class="bContent">
                         <div class="">
                           <el-form-item>
                                 <el-input-number size="medium" v-model="params1.area1"></el-input-number>
                           </el-form-item>
                           <span class="midspan">—</span>
                           <el-form-item>
                                 <el-input-number size="medium" v-model="params1.area2"></el-input-number>
                           </el-form-item>
                           <div class="tips">
                                 ㎡
                           </div>
                         </div>

                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">在租</div>
                     <div class="bContent">
                         <el-form-item>
                               <el-input-number size="medium" v-model="params2.onRent" :precision="0"></el-input-number>
                         </el-form-item>
                         <div class="tips">
                               套
                         </div>
                     </div>
                 </div>

                 <div class="text-block textarea clearfix">
                     <div class="bName">内容</div>
                     <div class="bContent">
                         <el-input
                             type="textarea"
                             :rows="5"
                             placeholder="请输入内容"
                             v-model="params1.content">
                         </el-input>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">联系人</div>
                     <div class="bContent">
                           <el-form-item>
                               <el-input size="medium" class="inpText" v-model="params1.contactPerson" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">联系电话</div>
                     <div class="bContent">
                           <el-form-item>
                               <el-input size="medium" class="inpText" v-model="params1.contactPhone" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block tag-block clearfix">
                     <div class="bName">标签</div>
                     <div class="bContent">
                          <tag-select :selectTags="params1.tagNames" paramsKey="tagNames" @selectChange="tagChange" />
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">头部图</div>
                     <div class="bContent">
                           <imgs-upload :files="params1.coverImage" @fileChange="imgChange" tips="（375*200推荐）" />
                     </div>
                 </div>

                 <div class="text-block radio-block clearfix">
                     <div class="bName">审核</div>
                     <div class="bContent">
                       <el-radio-group v-model="params1.status">
                          <el-radio :label="3">通过</el-radio>
                          <el-radio :label="4">不通过</el-radio>
                       </el-radio-group>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave" type="primary" size="small">保存</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { msgCreate,adsCreate,msgPredat } from "@/api/message/message";
import { dicSeek } from "@/api/pgMent/dictMent";
export default {
    components:{
        Editor
    },
    computed:{
      pgState:function(){
          var state = 0;
          if(this.id && !this.readyKey){
              state = 1;
          }

          if(this.uploadIng){
              state = 2;
          }

          return state;
      }
    },
    data(){
        return{

            id:'',
            uploadIng:false,
            readyKey:false,
            pageH:'',
            pathurl:'',

            adsStore:[],

            params1:{
                id:'',
                title:'',
                businessNewsType:'',
                businessNewsTypeId:'',
                content:'',
                coverImage:'',
                tagNames:'',
                contactPerson:'',   // 联系人
                contactPhone:'',    // 联系电话
                publisher:'',   // 发布企业

                officeArea:'',
                tagIds:'',

                officeLocationTypeId:'',
                officeLocationType:'',

                area1:'',
                area2:'',

                status:3,
            },

            params2:{
                id:'',
                businessNewsId:'',

                address:'',
                longitude:'',  // 经度
                latitude:'',  //  维度

                officeTypeId:'',
                officeType:'',

                subwayLine:'',  //  地铁路线
                subwayLineId:'',
                subwayStation:'',  //  站点名称
                distance:'',  // 距地铁站距离

                rentBegin:'', // 租金
                rentEnd:'',

                onRent:'',  // 在组
            },

            preCode:'',
            pgName:'',

            rules:{
                title:[{
                      required: true,
                      trigger: 'blur'
                }]
            }

        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        contentChange:function(e){    // 富文本内容
            this.params.content = e;
        },

        selectChange:function(e){

            if(e.paramsKey == 'officeLocationType'){
                this.params1[e.paramsKey] = e.name;
                this.params1[e.paramsKey + 'Id'] = e.id;
            }else{
                this.params2[e.paramsKey] = e.name;
                this.params2[e.paramsKey + 'Id'] = e.id;
            }

        },

        mapChange:function(e){    //  位置地点
            this.params2.address = e.name + ',' + e.id;
            if(e.address){
                this.params2.address = this.params2.address  + ',' + e.address;
            };
            this.params2.latitude = e.latLng.lat;
            this.params2.longitude = e.latLng.lng;
        },

        goCreate:async function(status){  // 创建
            var vues = this;
            var promiseArr = [];

            // promiseArr.push(new Promise((resolve,reject) => {
            //     msgCreate({businessNews:vues.params1}).then(res => {
            //         resolve(res);
            //     }).catch(err => {
            //         reject(err);
            //     })
            // }));
            //
            // promiseArr.push(new Promise((resolve,reject) => {
            //     adsCreate({businessOfficeLocation:vues.params2}).then(res => {
            //         resolve(res);
            //     }).catch(err => {
            //         reject(err);
            //     })
            // }));
            //
            // Promise.all(promiseArr).then(res => {
            //    vues.$router.push('ads_message');
            // })

            this.uploadIng = true;

            try {
                await msgCreate({businessNews:vues.params1});
                await adsCreate({businessOfficeLocation:vues.params2});
                vues.$router.push('ads_message');
            } catch (e) {
                vues.$message.error('保存错误！')
            } finally {
                vues.uploadIng = false;
            }

        },

        tmSave:function(){
            var vues = this;
            this.waitSave = setInterval(function(){
                var nowCode = JSON.stringify(vues.params);
                if(nowCode !== vues.preCode){
                    vues.goCreate(2);
                    vues.preCode = nowCode;
                }
            },60000)
        },

        directSave:function(){
            var vues = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    vues.goCreate();
                }

            })
        },

        imgChange:function(e){
            this.params1.coverImage = JSON.stringify(e);
        },

        // 标签
        tagChange:function(e){
            this.params1[e.paramsKey] = e.id;
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            this.params1.businessNewsTypeId = querys.typeid;

            // 底部定位
            this.pageFix();

            if(querys && querys.id){
                this.id = querys.id;
                this.params1.id = querys.id;
                vues.params2.businessNewsId = querys.id;
                msgPredat({id:querys.id}).then(res => {
                    vues.readyKey = true;
                    // vues.params1 = res.businessNews;
                    // vues.params2 = res.businessOfficeLocation;

                    for(let key in vues.params1){
                         if(res.businessNews[key]){
                            vues.params1[key] = res.businessNews[key];
                         }else{
                            vues.params1[key] = '';
                         }
                    }

                    for(let key in vues.params2){
                         if(res.businessOfficeLocation[key]){
                            vues.params2[key] = res.businessOfficeLocation[key];
                         }else{
                            vues.params2[key] = '';
                         }
                    }

                    // 所在地点
                    if(this.params2.address){
                        vues.adsStore = [{
                            name:this.params2.address.split(',')[0],
                            id:this.params2.address.split(',')[1],
                            address:this.params2.address.split(',')[2],
                            latLng:{
                            lng:this.params2.longitude,
                            lat:this.params2.latitude
                            }
                        }];
                    }
                })
            }else{

            }

        },
    },
    created:function(){
        var vues = this;

        $(window).on('resize',function(){
    		     vues.pageFix();
             vues.$refs.scroller1.sizeHeight = this.pageH;
    	  })

        this.prevSet();

    },

    beforeDestroy:function(){
        $(window).off('resize');
        clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 60px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 70px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }

          .midspan{
              margin: 0 12px;
              color: #AeAEAE;
          }
          .tips{
              display: inline-block;
              font-size: 12px;
              color: #AeAEAE;
              margin-top: 12px;
              margin-left: 12px;
          }
     }
}

.radio-block .el-radio-group{
     margin-top: 12px;
}

.tag-block{
   margin-top:20px;
   .bName{
        padding-top: 5px;
   }
}

.text-block.textarea .el-textarea{
   width: 50%;
}


</style>

<style lang="css">

.adsEdit .el-input__inner{
    border-radius: 0px;
}

.adsEdit .el-form-item{
  display: inline-block !important;
  margin-bottom: 0px;
}


</style>



// WEBPACK FOOTER //
// adsEdit.vue?24ded982